import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Tick: React.FC<IconProps> = ({
  className = '',
  fill = colors.green,
  width = 161,
  height = 122,
  polygonPoints = '51.2272727 96.5074627 12.8068182 58.2686567 0 71.0149254 51.2272727 122 161 12.7462687 148.193182 1.04591891e-10',
  cssHelper = Styling.transitionVisible,
  focusable = false
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={`0 0 ${width} ${height}`}
      width={`${width}px`}
      height={`${height}px`}
      cssHelper={cssHelper}
      fill={fill}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G stroke='none' stroke-width='1' fill={fill} fill-rule='evenodd'>
        <Elements.G transform='translate(-109.000000, -489.000000)' fill={fill}>
          <Elements.G transform='translate(109.000000, 489.000000)' fill={fill}>
            <Elements.Polygon points={polygonPoints} />
          </Elements.G>
        </Elements.G>
      </Elements.G>
    </Elements.Svg>
  );
};

export default Tick;
